import { invokeAdminAction } from '../utils/supabaseFunctions'

type SendOtpResult = { sent: boolean; expiresAt?: string }

function isNetworkOrServerError(error: unknown): boolean {
    const message = String((error as { message?: string })?.message || error || '').toLowerCase()
    return (
        message.includes('failed to fetch') ||
        message.includes('network') ||
        message.includes('timeout') ||
        message.includes('502') ||
        message.includes('503') ||
        message.includes('504') ||
        message.includes('functionshttperror')
    )
}

class OtpService {
    async isOtpEnabled(): Promise<boolean> {
        return true
    }

    /** Generates a 6-digit OTP, saves to DB and sends email — all server-side via edge function */
    async sendNewOtp(email: string, options?: { checkExistence?: boolean, type?: 'LOGIN' | 'RECOVERY' | 'STAFF' }): Promise<SendOtpResult> {
        try {
            const { data, error } = await invokeAdminAction({
                action: 'send-otp',
                data: {
                    email,
                    checkExistence: options?.checkExistence ?? false,
                    type: options?.type ?? 'LOGIN',
                    senderName: options?.type === 'RECOVERY' ? 'Happometer Team' : undefined,
                },
            })
            if (error) throw new Error(error.message)
            if (data?.error) throw new Error(data.error)
            if (data?.sendgridError) {
                console.warn(`[OTP] SendGrid failed: ${data.sendgridError}. Email sent via ${data.provider} (fallback).`)
            }
            return { sent: true, expiresAt: typeof data?.expiresAt === 'string' ? data.expiresAt : undefined }
        } catch (error: unknown) {
            console.error('[OTP SERVICE] Failed to send OTP:', error)
            throw error
        }
    }

    /** Verifies a code for an email via edge function — marks as used on success */
    async verifyOtp(email: string, code: string): Promise<{ valid: boolean; userId?: string; networkError?: boolean }> {
        try {
            const { data, error } = await invokeAdminAction({
                action: 'verify-otp',
                data: { email, code },
            })
            if (error) throw new Error(error.message)
            if (data?.error) throw new Error(String(data.error))
            return { valid: !!data?.valid, userId: data?.userId }
        } catch (error: unknown) {
            console.error('[OTP SERVICE] Verification Error:', error)
            if (isNetworkOrServerError(error)) {
                return { valid: false, networkError: true }
            }
            return { valid: false }
        }
    }
}

export const otpService = new OtpService()
